import React from 'react';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import Load from 'components/Load';
import basePath from 'utils/basePath';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import Notfound from 'modules/errorpages/Notfound';
import AppBottomPushDown from 'modules/common/Navbar/PushDown/AppBottomPushDown';
import LoadingDots from 'components/LoadingDots';
import {useAccount} from "~/authentication/store";

const AsyncRegistrationContainer = Load(() => import(/* webpackChunkName: "host-registration" */'./pages/RegistrationPage'));

const SubRoutes = () => {
  const { path } = useRouteMatch();
  const { loading } = useAccount();

  if (loading) {
    return (
      <LoadingDots />
    );
  }

  return (
    <Switch>
      <NavigationableLayout
        key="host-registration"
        path={`${path}/`}
        hideFooter
        component={AsyncRegistrationContainer}
        noNavbar
      />
      <Route>
        <Notfound />
      </Route>
    </Switch>
  );
};

const routes =
  <Route path={`${basePath}/host/register`}>
    <>
      <SubRoutes />
      <AppBottomPushDown/>
    </>
  </Route>;


export default routes;
